module.exports = __webpack_public_path__ + "img/xmqjt.c69ddfdd.png";